/**
 * 群公告弹窗的懒加载壳（21al；MessageMenuLazy 同构）。
 *
 * 弹窗只有点公告条/设置页那一行才出现，却被首屏的消息列表引用——放首屏块里
 * 纯占预算。加载期间渲染 null；块是本地的，点击到弹出通常一帧内。
 */
import { useLazyModule } from './useLazyModule';
import type { GroupNoticeDialogProps } from './GroupNoticeDialog';

export function GroupNoticeDialogLazy(props: GroupNoticeDialogProps) {
  const { mod } = useLazyModule(() => import('./GroupNoticeDialog'));
  if (mod === null) return null;
  return <mod.GroupNoticeDialog {...props} />;
}
